<template>
  <div class="account-setting">
    <div class="Lists">
      <van-cell-group>
        <van-cell
          title="李四修理厂"
          value="+1000元"
          label="2021-10-10 18:16:13"
        />
        <van-cell
          title="李四修理厂"
          value="+1000元"
          label="2021-10-10 18:16:13"
        />
        <van-cell
          title="李四修理厂"
          value="+1000元"
          label="2021-10-10 18:16:13"
        />
        <van-cell
          title="李四修理厂"
          value="+1000元"
          label="2021-10-10 18:16:13"
        />
      </van-cell-group>
    </div>
    <div class="img">
      <van-image
        fit="cover"
        :round="true"
        width="5rem"
        height="5rem"
        :src="require('@/assets/delivery/Remember.png')"
        @touchstart.native.stop="show = true"
      />
    </div>
    <van-number-keyboard
      :show="show"
      theme="custom"
      extra-key="."
      close-button-text="完成"
      @blur="show = false"
      @input="onInput"
      @delete="onDelete"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  mounted() {},
  methods: {
    onInput(value) {
      this.$toast(value);
    },
    onDelete() {
      this.$toast("删除");
    },
  },
};
</script>
<style lang="scss" scoped>
.account-setting {
  height: 97vh;
  position: relative;
  .Lists {
    width: 85%;
    margin: 0 auto;
    text-align: initial;
    margin-top: 1rem;
  }
  .img {
    position: absolute;
    bottom: 3rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
